// Pure helpers for the API tab (/api). The numbers mirror the backend: functions/general/api_functions/keys.py
// (MAX_KEYS) and the generator's chat_context.PRO_MESSAGE_LIMIT (questions per video, shared with web chat).
export const MAX_KEYS = 5;
export const QUESTIONS_PER_VIDEO = 25;
// A 7-minute public video from the onboarding examples (myWorkspace/onboarding/examples.js), long enough for chapters
const SAMPLE_URL = 'https://www.youtube.com/watch?v=1W4bRAKfMeM';

export const apiBaseUrl = origin => `${origin}/api/v1`;

// The API's status for a workspace doc, by the same rules as video_state in api_functions/views.py (without the
// deadline, which the API applies when the video is next read)
export function apiVideoStatus(ws) {
  if (ws.timestamps) return 'ready';
  if (ws.api_error || ws.is_transcript_error || ws.sc_video_private) return 'failed';
  if (ws.is_sc_run && !ws.sc_in_progress) return 'failed';
  return 'processing';
}

export const minutesFor = seconds => Math.max(Math.floor((seconds || 0) / 60), 1);

export function snippets(baseUrl) {
  return {
    curl: [
      `curl -X POST ${baseUrl}/videos \\`,
      '  -H "Authorization: Bearer $BUMPUPS_API_KEY" \\',
      '  -H "Content-Type: application/json" \\',
      '  -H "Idempotency-Key: $(uuidgen)" \\',
      `  -d '{"url": "${SAMPLE_URL}"}'`,
      '',
      '# Then check back until "status" is "ready" or "failed":',
      `curl ${baseUrl}/videos/VIDEO_ID -H "Authorization: Bearer $BUMPUPS_API_KEY"`,
    ].join('\n'),
    python: [
      'import os, time, uuid, requests',
      '',
      `API = "${baseUrl}"`,
      'HEADERS = {"Authorization": f"Bearer {os.environ[\'BUMPUPS_API_KEY\']}"}',
      '',
      `video = requests.post(f"{API}/videos", json={"url": "${SAMPLE_URL}"},`,
      '                      headers={**HEADERS, "Idempotency-Key": str(uuid.uuid4())}).json()',
      'while video.get("status") == "processing":',
      '    time.sleep(15)',
      '    video = requests.get(f"{API}/videos/{video[\'id\']}", headers=HEADERS).json()',
      'print(video.get("chapters_text") or video)',
    ].join('\n'),
    javascript: [
      `const API = '${baseUrl}';`,
      "const headers = { Authorization: 'Bearer ' + process.env.BUMPUPS_API_KEY, 'Content-Type': 'application/json' };",
      '',
      "let video = await fetch(API + '/videos', {",
      "  method: 'POST',",
      "  headers: { ...headers, 'Idempotency-Key': crypto.randomUUID() },",
      `  body: JSON.stringify({ url: '${SAMPLE_URL}' }),`,
      '}).then(r => r.json());',
      "while (video.status === 'processing') {",
      '  await new Promise(r => setTimeout(r, 15000));',
      "  video = await fetch(API + '/videos/' + video.id, { headers }).then(r => r.json());",
      '}',
      'console.log(video.chapters_text ?? video);',
    ].join('\n'),
  };
}
